import React from 'react'

import { Box } from '@material-ui/core'
import { Text } from '..'

import useStyles from './styles'

const VideoPage = ({ title, url }) => {
  const classes = useStyles()

  return (
    <Box width="100%" display="flex" flexDirection="column" mb={2}>
      <Text fontSize="6vh" variant="h4" gutterBottom>
        {title}
      </Text>
      <iframe
        title="Vídeo explicativo do treinamento"
        src={url}
        frameBorder="0"
        className={classes.video}
        allowFullScreen
        width="100%"
        allow={'picture-in-picture; fullscreen'}
      />
    </Box>
  )
}

export default VideoPage
